import { ApiProperty } from "@nestjs/swagger";

export class ReProcessingDtoReq{
    @ApiProperty()
    product: number;
    @ApiProperty()
    brand: number;
    @ApiProperty()
    minGrade: number;
    @ApiProperty()
    maxGrade: number;
    @ApiProperty()
    finalPercentage?:number;
    @ApiProperty()
    requiredRmQty?:number;
    @ApiProperty()
    variantId?:number[];
}